export default __webpack_public_path__ + "bullseye.png";